module.exports = [{
      plugin: require('../../../plugins/gatsby-powergo-brp-smartsite-theme/gatsby-browser.js'),
      options: {"plugins":[],"instockToken":"5775798b043930d1a428d8a3eed2b92c20e31c85","sourceEnv":"production","websiteDomain":"www.harper-marine.com"},
    },{
      plugin: require('../../../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
